import * as React from "react";
const ButtonRoundedSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 7v4H4V7h10ZM4 6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4Z" }));
ButtonRoundedSmall.displayName = "ButtonRoundedSmall";
var ButtonRoundedSmall_default = ButtonRoundedSmall;
export {
  ButtonRoundedSmall_default as default
};
